import React, { useEffect, useState } from 'react';
import { BackPage, Spinner, Checkbox } from 'components';
import styles from './style.module.css';
import { useConsent } from 'hooks';
import { useHistory } from 'react-router-dom';

const NotificationPermissions = () => {
  const [consents, loading, putConsents] = useConsent();
  const [form, setForm] = useState({});
  const [preferenceChange, setPreferenceChange] = useState(false);
  const history = useHistory();

  useEffect(() => {
    !loading &&
      setForm((state) => ({
        ...state,
        ...consents,
        order_updates_email_consent: true
      }));
  }, [loading]);

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setForm((state) => ({
      ...state,
      [name]: checked,
      order_updates_email_consent: true
    }));
    setPreferenceChange(true)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(form).length > 0) {
      await putConsents(form);
    }
  };

  const formOptions = [
    {
      heading: 'Order Updates',
      description: 'Receive updates on the progress of your order, so you know when your medication will be ready',
      options: [
        {
          heading: 'Push Notification**',
          name: 'order_updates_push_notification_consent',
          description: '**Hey Pharmacist App required to receive push notification',
        },
        {
          heading: 'Email*',
          name: 'order_updates_email_consent',
          description: '*Always enabled',
        },
      ],
    },
    {
      heading: 'Order Reminders',
      description: 'Set reminders for when you can next order your medication',
      options: [
        {
          heading: 'Push Notification',
          name: 'order_reminder_push_notification_consent',
        },
        {
          heading: 'Email',
          name: 'order_reminder_email_consent',
        },
      ],
    },
    {
      heading: 'Pharmacy Services',
      description:
        'Be first to hear about the latest health services available, such as flu and pneumonia vaccinations',
      options: [
        {
          heading: 'Push Notification',
          name: 'pharmacy_services_push_notification_consent',
        },
        {
          heading: 'Email',
          name: 'pharmacy_services_email_consent',
        },
      ],
    },
    {
      heading: 'Survey & User Research',
      description: 'Want to help us improve our app? Get involved in our user research sessions',
      options: [
        {
          heading: 'Push Notification',
          name: 'user_research_push_notification_consent',
        },
        {
          heading: 'Email',
          name: 'user_research_email_consent',
        },
      ],
    },
    {
      heading: 'News and Promotions',
      description: 'Receive news, health information and marketing communications.',
      options: [
        {
          heading: 'Push Notification',
          name: 'news_push_notification_consent',
        },
        {
          heading: 'Email',
          name: 'news_email_consent',
        },
      ],
    },
  ];

  if (loading || Object.keys(form).length === 0) {
    return (
      <>
        <div className="coop-l-container">
          <div className={styles.loadingSpinner}>
            <Spinner />
          </div>
        </div>
      </>
    );
  }

  return (
    <BackPage onBackClick={() => history.goBack()} bplg="10">
      <div className="coop-l-container">
        <h1 className={styles.pageHeader}>Notification Permissions</h1>
        <div className={styles.wrapper}>
          <div>
            {formOptions.map((formItem) => {
              return (
                <div key={formItem.heading} className={styles.formOptionContainer}>
                  <div className={styles.formHeadingContainer}>
                    <h2 className={styles.subHeading}>{formItem.heading}</h2>
                    <p>{formItem.description}</p>
                  </div>
                  {formItem.options.map((formInput, index) => {
                    return (
                      <div key={formInput.name} className={styles.formInputContainer}>
                        <Checkbox
                          checked={form[formInput.name]}
                          name={formInput.name}
                          label={formInput.name}
                          handleChange={handleChange}
                          index={index}>
                          <h3>{formInput.heading}</h3>
                          <p>{formInput.description}</p>
                        </Checkbox>
                        <div className={styles.formLabelContainer}></div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
            <button
              className={`coop-btn coop-btn--primary ${styles.button}`}
              onClick={handleSubmit}
              onKeyPress={(e) => e.key === 'Enter' && handleSubmit}
              disabled={!preferenceChange}
              >
              Save
            </button>
          </div>
        </div>
      </div>
    </BackPage>
  );
};

export default NotificationPermissions;
